import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
// import Text from 'ol/style/Text';
import { Draw, Modify, Snap } from 'ol/interaction';

import { filterDatalist } from '../formal';
import { enrichInformation } from './feature-tools';
import { addLayerToList, addToPlanIdList, getListItemFromLayer } from '../list';
import { warn } from '../notify';
import { planStyle } from './styles';
import { getLayerById } from './layer-tools';
import { zoomToFeature } from './tools';
import * as wizard from '../wizard';

const maxArea = 1000000; // dekar

const currentRadio = document.getElementById('currentRadio');
const kommuneRadio = document.getElementById('kommuneRadio');
const reguleringsRadio = document.getElementById('reguleringsRadio');

const retrievePlanCategory = () => {
  if (currentRadio.checked) return currentRadio.value;
  if (kommuneRadio.checked) return kommuneRadio.value;
  if (reguleringsRadio.checked) return reguleringsRadio.value;
  return null;
};

const categoryToType = {
  Kommuneplan: 'KpArealformålOmråde',
  Reguleringsplan: 'RpArealformålOmråde',
  Nåværende: 'Nåværende'
};

const s = new VectorSource();
const drawings = new VectorLayer({
  properties: { id: 'drawings', label: 'tegning', type: 'drawings' },
  source: s,
  style: planStyle
});

const draw = new Draw({ source: s, type: 'Polygon', stopClick: true });
// const modify = new Modify({ source: s });
const snap = new Snap({ source: s })

export const drawInitialization = (map) => {
  map.addInteraction(new Modify({ source: s }));
  map.addLayer(drawings);

  let n = '@';
  draw.on('drawend', (e) => {
    const f = e.feature;
    f.setId(f.ol_uid); // VectorSource#getFeatureById
    // console.log('drawend', f.getId());

    rightSize(f);

    n = String.fromCharCode(n.charCodeAt() + 1) // next character
    // f.setProperties({ id: f.ol_uid, title: 'Område ' + n });
    const planid = `Område ${n}`;
    const pk = retrievePlanCategory();
    const pt = pk ? categoryToType[pk] : 'Nåværende';
    // To be able to use enrichInformation, we need:
    f.setProperties({
      // arealformål: 1001,
      checked: true,
      drawn: true,
      feltbetegnelse: [n],
      NASJONALAREALPLANID: { planidentifikasjon: planid },
      objekttypenavn: pt
    });
    // f.setStyle(new Style({
    //   text : new Text({
    //     text: n, font: 'bold 24px sans-serif', overflow: true
    //   })
    // }));

    enrichInformation(f);
    if (!getLayerById('drawings')) map.addLayer(drawings);
    const li = getListItemFromLayer(drawings) || addLayerToList(drawings);
    addToPlanIdList(planid, drawings, li.querySelector('ul'), 'drawn');

    if (pk && !currentRadio.checked) {
      document.getElementById('formål').value = '';
      document.getElementById('formålChoiceGroup').hidden = false;
      filterDatalist(pk);
    }

    wizard.moveTo('selection');
    wizard.show();
    removeInteractions();
    isDrawing = false;
  });

  const addInteractions = () => {
    map.addInteraction(draw);
    // map.addInteraction(modify);
    map.addInteraction(snap);
  };

  const removeInteractions = () => {
    map.removeInteraction(draw);
    // map.removeInteraction(modify);
    map.removeInteraction(snap);
  };

  let isDrawing = false;

  document.getElementById('tegnBtn').onclick = () => {
    wizard.hide();

    if (isDrawing) {
      // console.log('remove interactions');
      removeInteractions();
      isDrawing = false;
    } else {
      // console.log('add interactions');
      isDrawing = true;
      addInteractions();
    }
  };

};

export const rightSize = (f) => {
  const area = f.getGeometry().getArea();
  const dekar = Math.round(area / 1000);

  if (dekar > maxArea) {
    const a = dekar.toLocaleString('no-NO');
    const max = maxArea.toLocaleString('no-NO');
    const name = f.get('title') ? ` «${f.get('title')}»` : '';
    warn(`
      Området${name} er ${a} dekar. Maks størrelse er ${max} dekar.
      Endre området eller slett og tegn et mindre område.
    `);
    return false;
  }
  return true;
};

export const assignFormålToLastDrawing = (code) => {
  const ff = s.getFeatures();
  const lastDrawnFeature = ff[ff.length - 1];
  lastDrawnFeature.set('arealformål', code);
  lastDrawnFeature.set('formål', code);
  enrichInformation(lastDrawnFeature);
};

export const assignPlanCategoryToLastDrawing = (category) => {
  const ff = s.getFeatures();
  const lastDrawnFeature = ff[ff.length - 1];
  lastDrawnFeature.set('plankategori', category);
  const pt = category ? categoryToType[category] : 'Nåværende';
  lastDrawnFeature.set('objekttypenavn', pt);
  lastDrawnFeature.set('planType', pt);
  if (pt === 'Nåværende') lastDrawnFeature.unset('arealformål');
  if (pt === 'Nåværende') lastDrawnFeature.unset('formål');
};

